<i18n>
{
	"en": {
		"template": "Template",
		"createFromTemplate": "Create trip from template"
	},
	"no": {
		"template": "Mal",
		"createFromTemplate": "Opprett tur fra mal"
	}
}
</i18n>

<template>
	<t-form-group :title="$t('template')" rowGap="5px">
		<t-select
			:selectedItem="selectedItem"
			:items="tripTemplates"
			displayName="name"
			showPopoverOnFocus
			@select="$emit('select', $event)"
		>
			<template v-slot:displayedValue="{ popoverShow }">
				{{ selectedItem ? selectedItem.name : $t('createFromTemplate') }}
			</template>
		</t-select>
	</t-form-group>
</template>

<script>
import { mapState, mapActions } from './store/tripTemplates.store';

export default {
	name: 'TripTemplateFormInput',
	props: { selectedItem: Object },
	computed: { ...mapState(['tripTemplates']) },
	mounted() { this.getTripTemplates(); },
	methods: { ...mapActions(['getTripTemplates']) },
};
</script>

<style lang="scss" scoped>

</style>
